import React, { useMemo } from "react";
import styles from "./LineReChart.module.scss";
import { LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer } from "recharts";

export const CustomTooltip = ({ active, payload, label }: any) => {
	if (!active || !payload || payload.length === 0) {
		return null;
	}
	const value = payload[0].value;

	// Format tooltip label
	const formattedLabel = new Date(label).toLocaleDateString("en-GB", {
		day: "2-digit",
		month: "short",
	});

	return (
		<div style={{ backgroundColor: "#fff", border: "1px solid #ddd", padding: "8px" }}>
			<p style={{ margin: 0 }}>{`${formattedLabel} - ${value}`}</p>
		</div>
	);
};

export default function StyledSpikeLineChart({ rawData=[] }: { rawData: Array<{ date: string; value: number }> }) {
	// Memoize data (optional: parse date once)
const data = useMemo(() => {
  if (!rawData) return [];
  return [...rawData].sort(
    (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
  );
}, [rawData]);
	
	const maxLabels = 6;
	const interval = Math.floor(data.length / maxLabels);

	return (
		<div className={styles.chart} style={{ backgroundColor: "#ffffff", padding: "0" }}>
			<ResponsiveContainer width="100%" height="100%">
				<LineChart data={data} margin={{ top: 10, right: 30, left: 0, bottom: 10 }}>
					<CartesianGrid strokeDasharray="3 3" stroke="#ccc" vertical={false} />

					<XAxis
						dataKey="date"
						tickLine={false}
						tick={{ fill: "#888", fontSize: 12 }}
						height={30}
						padding={{ left: 10, right: 10 }}
						interval={interval}
						minTickGap={20}
						// ✅ format: 25 Oct
						tickFormatter={(tick) => {
							const d = new Date(tick);
							return d.toLocaleDateString("en-GB", {
								day: "2-digit",
								month: "short",
							});
						}}
					/>

					<YAxis
						axisLine={false}
						tickLine={false}
						tick={{ fill: "#888", fontSize: 12 }}
						domain={[0, "dataMax + 50"]}
					/>

					<Tooltip content={<CustomTooltip />} />

					<Line
						type="monotone"
						dataKey="value"
						stroke="#4D4DE9"
						strokeWidth={3}
						dot={false}
						activeDot={{ r: 6, fill: "#4D4DE9" }}
					/>
				</LineChart>
			</ResponsiveContainer>
		</div>
	);
}
